import axios from 'axios'
import { API_BASE_URL } from '@/config/api.config'
import { STORAGE_KEYS } from '@/config/constants'

const AUTH_URL = `${API_BASE_URL}/auth/token/`
const USERS_URL = `${API_BASE_URL}/users/`

class AuthService {
  login(user) {
    return axios
      .post(AUTH_URL, {
        username: user.username,
        password: user.password,
      })
      .then(response => {
        if (response.data.access) {
          localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(response.data))
        }
        return response.data
      })
  }

  logout() {
    localStorage.removeItem(STORAGE_KEYS.USER)
    localStorage.removeItem(STORAGE_KEYS.SELECTED_CITY)
  }

  register(user) {
    return axios.post(`${USERS_URL}create_user/`, {
      username: user.username,
      email: user.email,
      password: user.password,
    })
  }

  getCurrentUser() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEYS.USER))
    } catch (e) {
      localStorage.removeItem(STORAGE_KEYS.USER)
      return null
    }
  }

  refreshToken() {
    const user = this.getCurrentUser()
    if (user && user.refresh) {
      return axios.post(`${AUTH_URL}refresh/`, {
        refresh: user.refresh,
      }).then(response => {
        if (response.data.access) {
          user.access = response.data.access
          localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user))
        }
        return response.data
      })
    }
    return Promise.reject('No refresh token available')
  }
}

export default new AuthService()
